import { Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import useWebframePermissions from '../../../hooks/useWebframePermissions';
import { t } from '../../../utils/resources';

type ModuleLinkSectionProps = {
  module: string;
  permission: string;
  onClick: (module: string) => void;
  title: string;
  description: string;
};

export const ModuleLinkSection = ({
  module,
  title,
  description,
  permission,
  onClick,
}: ModuleLinkSectionProps) => {
  const { isGranted } = useWebframePermissions();

  return (
    <li>
      <div className="submenu-item">
        {isGranted(permission) ? (
          <Link to={module} onClick={() => onClick(module)}>
            {title}
          </Link>
        ) : (
          <Link className="disabledCursor" to={module} onClick={(event) => event.preventDefault()}>
            {title}
          </Link>
        )}
      </div>

      <div className="menu-hover-container">
        <Header as="h1">{title}</Header>
        {isGranted(permission) ? <p>{description}</p> : <p>{t('Menu.NoAccessToModule')}</p>}
      </div>
    </li>
  );
};
